export interface FormProps extends React.FormHTMLAttributes<HTMLFormElement> {}

export default function Form(props: Readonly<FormProps>) {
  return <form {...props} />;
}
